"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 1a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM11 1a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1V1zM0 12a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1v-7z"];
//# sourceMappingURL=layout-top-row-two-tiles.js.map